import { Observable } from 'rxjs';
import { Component } from './component';

export class ComponentState {
  ShowBadge: boolean;
  Routes?: Array<string> = [];
  Data?: Array<any>;
  Component: Component = new Component();
  ComponentId: string;
  Refresh?: boolean;
  CheckForUpdatedContent?: Observable<any>;
  LastCheckedForNewContent?: Date;

  constructor(opt?: Partial<ComponentState>) {
    Object.assign(this, opt);
  }
}
